export default "__VITE_ASSET__BQvF3xoq__"